import {useStyles} from '../../../../../shared/hooks/styles';
import {hexWithAlpha} from '../../../../../shared/components/gradientView';

const CELL_SPACING = 40;

export const GetDesktopTableStyles = () => {
  return useStyles(({theme}) => ({
    container: {
      width: 'auto',
      maxWidth: 900,
    },
    noData: {
      paddingVertical: 24,
      color: theme.color.grayMenu,
    },
    headCell: {
      ...theme.fonts.body,
      color: theme.color.grayMenu,
      marginRight: CELL_SPACING,
    },
    cell: {
      marginRight: CELL_SPACING,
    },
    colDescription: {
      flexBasis: 417,
      maxWidth: 417,
    },
    colAmount: {
      flexBasis: 203,
      maxWidth: 203,
      textAlign: 'end',
    },
    colDate: {
      flexBasis: 114,
      flexGrow: 1,
    },
    link: {
      color: theme.color.primaryColor,
      ...theme.fonts.h6,
    },
  }));
};

export const GetMobileTableStyles = () => {
  return useStyles(({theme}) => ({
    container: {},
    noData: {
      paddingVertical: 24,
      color: theme.color.grayMenu,
      ...theme.fonts.h6,
    },
    item: {
      borderWidth: 1,
      borderColor: theme.color.grayMenu,
      borderRadius: 14,
      overflow: 'hidden',
      marginBottom: 16,
    },
    itemHead: {
      paddingHorizontal: 20,
      paddingVertical: 8,
    },
    itemBody: {
      paddingHorizontal: 20,
      paddingVertical: 8,
      flexDirection: 'row',
      justifyContent: 'space-between',
      backgroundColor: hexWithAlpha(theme.color.primaryColor, 0.15),
    },
    itemBodyDate: {
      color: theme.color.grayMenu,
    },
    link: {
      color: theme.color.primaryColor,
    },
  }));
};
